import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import HttpRoute from "../../../dce-ajax/lib/utils/HttpRoute";
import {DceAjax} from "dce-ajax";

interface CheckboxChangeListProps {
    call?: string;
    loading: boolean
}

@Dce("CheckboxChangeList")
export default class CheckboxChangeList extends DceComponent<CheckboxChangeListProps> {

    private route: HttpRoute;

    constructor(elem: DceHTMLElement, props: CheckboxChangeListProps) {
        super(elem, props);
        this.route = HttpRoute.of(this.props.call);
    }

    public change(e:Event){
        e.preventDefault();
        let target = e.target as HTMLInputElement;

        let selected = 0;
        if(target.checked){
            selected = 1;
        }

        if(this.props.loading) {
            this.elem.classList.add('loading');
        }

        DceAjax.getInstance()
            .get(this.route.build(target.value, selected.toString()))
            .then(res => {
                if(this.props.loading){
                    this.elem.classList.remove('loading')
                }

                if(res.hasResponse()){
                    let newdiv = CheckboxChangeList.createElem(res.response);
                    this.elem.replaceWith(newdiv);
                }

            });

        console.log("CHANGE", e);

    }

    public static createElem(elem: string): Element {
        let d = document.createElement('div');
        d.innerHTML = elem;
        return d.firstElementChild;
    }

    defaultProps(): Partial<CheckboxChangeListProps> {
        return {
            loading: false
        }
    }
}
